class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.setAttribute("open", true)
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.removeAttribute("open");
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      document.getElementById(section.id).innerHTML = content;
    }));

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {

    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

class CartNotificationDrawer extends HTMLElement {
  isOpen = false;
  element = undefined;
  container = "cart-notification-product"
  selector = "#cart-notification-product-list"

  constructor() {
    super();

    this.notification = this.querySelector("cart-notification");

    this.addEventListener("mouseenter", this.handleOpen.bind(this));
    this.addEventListener("mouseleave", this.handleClose.bind(this));
  }

  fetchCart() {
    return new Promise((resolve, reject) => {
      fetch(`/?sections=${this.container}`)
        .then((response) => response.json())
        .then((response) => {
          resolve(response[this.container])
        })
        .catch((e) => {
          reject(e)
        });
    })
  }

  getSectionHTML(html, selector = this.selector) {
    const content = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;

    return content;
  }

  handleOpen() {
    this.setAttribute("hovering", true);

    const open = debounce(() => {
      if (this.hasAttribute("hovering")) {
        this.open()
      }
    }, 300);

    open();
  }

  handleClose() {
    this.removeAttribute("hovering")
  }

  open() {
    if (this.isOpen && this.notification.hasAttribute("open")) {
      return
    }

    if (this.notification.hasAttribute("open")) {
      this.isOpen = true;

      return
    }

    document.getElementById(this.container).innerHTML = ""
    this.isOpen = true;
    this.notification.setAttribute("loading", true);
    this.notification.open();

    this.fetchCart()
      .then(content => {
        this.notification.removeAttribute("loading");
        document.getElementById(this.container).innerHTML = this.getSectionHTML(content)
      });
  }

  close() {
    this.notification.close();

    this.isOpen = false;
  }
}

customElements.define('cart-notification-drawer', CartNotificationDrawer);